// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Chat Sidebar New Conversation and Forward Message */

.roq-chat-create-conversation-sidebar__header__top__action svg {
  transform: scale(0.8);
}

/* Hide default title */
.roq-chat-create-conversation-sidebar__header__top__title {
  display: none;
}

.roq-chat-sidebar-search {
  margin-top: var(--spacing-small);
  position: relative;
}

.roq-chat-sidebar-search__icon {
  inset: 0 auto;
  left: var(--spacing-small);
  margin: auto 0 auto var(--spacing-small);
  position: absolute;
  stroke: var(--color-icons-alt-active);
  transform: scale(1.2);
}

.roq-chat-sidebar-search__input {
  background-color: var(--color-hover-day-light);
  border: none;
  border-radius: var(--border-radius-huge);
  font-size: var(--font-baseline);
  min-height: var(--preference-select-item-min-height);
  outline: none;
  padding: var(--spacing-tiny);
  padding-left: var(--size-input-padding-left);
  width: 100%;
}

.roq-chat-sidebar-search__input::placeholder {
  color: var(--color-text-regular);
}

.roq-chat-member-list__list__meber {
  align-items: center;
  border-radius: var(--border-radius-huge);
  cursor: pointer;
  display: flex;
  gap: var(--spacing-small);
  min-height: var(--preference-select-item-min-height);
  padding: var(--spacing-small);
}

.roq-chat-member-list__list__meber:hover {
  background-color: var(--color-hover-day-light);
}

.roq-chat-member__content {
  -webkit-box-orient: vertical;
  display: -webkit-box;
  flex-grow: 1;
  -webkit-line-clamp: var(--preference-label-line-clamp);
  overflow: hidden;
  text-wrap: wrap;
}
`, "",{"version":3,"sources":["webpack://./src/styles/css/roqChat/_sidebar-conversation-new.css"],"names":[],"mappings":"AAAA,sDAAsD;;AAEtD;EACE,qBAAqB;AACvB;;AAEA,uBAAuB;AACvB;EACE,aAAa;AACf;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,wCAAwC;EACxC,kBAAkB;EAClB,qCAAqC;EACrC,qBAAqB;AACvB;;AAEA;EACE,8CAA8C;EAC9C,YAAY;EACZ,wCAAwC;EACxC,+BAA+B;EAC/B,oDAAoD;EACpD,aAAa;EACb,4BAA4B;EAC5B,4CAA4C;EAC5C,WAAW;AACb;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,wCAAwC;EACxC,eAAe;EACf,aAAa;EACb,yBAAyB;EACzB,oDAAoD;EACpD,6BAA6B;AAC/B;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,4BAA4B;EAC5B,oBAAoB;EACpB,YAAY;EACZ,sDAAsD;EACtD,gBAAgB;EAChB,eAAe;AACjB","sourcesContent":["/* Chat Sidebar New Conversation and Forward Message */\n\n.roq-chat-create-conversation-sidebar__header__top__action svg {\n  transform: scale(0.8);\n}\n\n/* Hide default title */\n.roq-chat-create-conversation-sidebar__header__top__title {\n  display: none;\n}\n\n.roq-chat-sidebar-search {\n  margin-top: var(--spacing-small);\n  position: relative;\n}\n\n.roq-chat-sidebar-search__icon {\n  inset: 0 auto;\n  left: var(--spacing-small);\n  margin: auto 0 auto var(--spacing-small);\n  position: absolute;\n  stroke: var(--color-icons-alt-active);\n  transform: scale(1.2);\n}\n\n.roq-chat-sidebar-search__input {\n  background-color: var(--color-hover-day-light);\n  border: none;\n  border-radius: var(--border-radius-huge);\n  font-size: var(--font-baseline);\n  min-height: var(--preference-select-item-min-height);\n  outline: none;\n  padding: var(--spacing-tiny);\n  padding-left: var(--size-input-padding-left);\n  width: 100%;\n}\n\n.roq-chat-sidebar-search__input::placeholder {\n  color: var(--color-text-regular);\n}\n\n.roq-chat-member-list__list__meber {\n  align-items: center;\n  border-radius: var(--border-radius-huge);\n  cursor: pointer;\n  display: flex;\n  gap: var(--spacing-small);\n  min-height: var(--preference-select-item-min-height);\n  padding: var(--spacing-small);\n}\n\n.roq-chat-member-list__list__meber:hover {\n  background-color: var(--color-hover-day-light);\n}\n\n.roq-chat-member__content {\n  -webkit-box-orient: vertical;\n  display: -webkit-box;\n  flex-grow: 1;\n  -webkit-line-clamp: var(--preference-label-line-clamp);\n  overflow: hidden;\n  text-wrap: wrap;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
